/* eslint-disable consistent-return */
import { useState, KeyboardEvent } from 'react'
import { toast } from 'react-toastify'
import { useLocation, useNavigate } from 'react-router-dom'
import { redefinicaoSenha } from '../../services/AlteraSenha/postAlteraSenha'

export const useAlteraSenha = () => {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const token = params.get('token')
  const email = params.get('email')

  const navigate = useNavigate()
  const goToPage = () => {
    navigate(`/`)
  }

  const [senha, setSenha] = useState('')
  const [senhaInvalida, setSenhaInvalida] = useState(false)
  const [isValid, setIsValid] = useState(false)
  const [confirmarSenha, setConfirmarSenha] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [campoObrigatorioNovaSenha, setCampoObrigatorioNovaSenha] =
    useState(false)
  const [campoObrigatorioConfirmarSenha, setCampoObrigatorioConfirmarSenha] =
    useState(false)
  const [senhaNaoCoincide, setSenhaNaoCoincide] = useState(false)

  const alterarSenhaDTO = {
    confirmacaoSenha: confirmarSenha,
    email,
    senha,
    token,
  }
  const redefinirSenha = async () => {
    setIsLoading(true)
    const redefineSenha = await redefinicaoSenha(alterarSenhaDTO)
    setIsLoading(false)
    if ('info' in redefineSenha) {
      toast.success(redefineSenha.info)
      const timer = setTimeout(() => {
        goToPage()
      }, 1500)
      return () => clearTimeout(timer)
    }
    toast.error(redefineSenha.message)
  }

  const validatePassword = (password: any) => {
    // Regex para verificar pelo menos uma letra maiúscula, uma letra minúscula e um número.
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
    return regex.test(password)
  }

  const handleRedefinirSenha = () => {
    setSenhaNaoCoincide(false)
    setCampoObrigatorioConfirmarSenha(false)
    setCampoObrigatorioNovaSenha(false)
    setSenhaInvalida(false)

    if (senha.length === 0) {
      setCampoObrigatorioNovaSenha(true)
      return
    }
    if (confirmarSenha.length === 0) {
      setCampoObrigatorioConfirmarSenha(true)
      return
    }
    if (senha !== confirmarSenha) {
      setSenhaNaoCoincide(true)
      return
    }

    const senhaValida = validatePassword(senha)
    setIsValid(senhaValida)
    if (!isValid) {
      setSenhaInvalida(true)
      return
    }

    redefinirSenha()
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleRedefinirSenha()
    }
  }

  return {
    senha,
    setSenha,
    confirmarSenha,
    setConfirmarSenha,
    isLoading,
    handleKeyDown,
    campoObrigatorioNovaSenha,
    campoObrigatorioConfirmarSenha,
    senhaNaoCoincide,
    handleRedefinirSenha,
    senhaInvalida,
  }
}
